import {APIPromise} from "../services/HttpService";
import {ApiDefinition} from "./ApiDefinition";
import {Dashboard} from "./model/dashboard/Dashboard";

class DashboardApiDefinition extends ApiDefinition {
    constructor() {
        super("/dashboard");
    }

    async getAllDashboards(): APIPromise<Array<Dashboard>> {
        return this.get("infos");
    }

    async getDashboard(dashboardId: number): APIPromise<Dashboard> {
        return this.get(`${dashboardId}`);
    }

    async getDashboardsInfos(dashboardsId: Array<number>): APIPromise<Array<Dashboard>> {
        return this.get(`infos`, {params:{id:dashboardsId}});
    }

    async updateDashboard(dashboard: Dashboard, allowOverwrite? : boolean): APIPromise<Dashboard> {
        return this.post(null, dashboard, { params: { allowOverwrite } });
    }
}

export const DashboardApi = new DashboardApiDefinition();
